export default __webpack_public_path__ + "static/media/auvik.5b5f0f29.jpg";